/**
 * @generated SignedSource<<4fc4d672e712f3a8d3407a736b873ba2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCompanyInput = {
  name?: string | null;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  country?: string | null;
  currency?: string | null;
  timezone?: string | null;
  vatId?: string | null;
  logoId?: string | null;
  defaultRateCardId?: string | null;
  defaultHolidayCalendarId?: string | null;
  defaultExpenseCategoryId?: string | null;
  defaultRevenueMarginLow?: number | null;
  defaultRevenueMarginHigh?: number | null;
  disableNotifications?: boolean | null;
  timeRegNotificationSchedule?: string | null;
  projectOverviewNotificationSchedule?: string | null;
  contactPersonId?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  companyTarget?: number | null;
  monday?: number | null;
  tuesday?: number | null;
  wednesday?: number | null;
  thursday?: number | null;
  friday?: number | null;
  saturday?: number | null;
  sunday?: number | null;
  useTimeApproval?: boolean | null;
  restrictCollaboratorSeatPermissions?: boolean | null;
  useInternalTimeApproval?: boolean | null;
  useTimeOffApproval?: boolean | null;
  allUsersModifyTimeOff?: boolean | null;
  defaultUseTaskOwner?: boolean | null;
  defaultUseTaskFollowers?: boolean | null;
  cascadeDependencyDates?: boolean | null;
  harvestDeactivate?: boolean | null;
  timelogDeactivate?: boolean | null;
  economicDeactivate?: boolean | null;
  slackDeactivate?: boolean | null;
  gitlabDeactivate?: boolean | null;
  gitlabServerDeactivate?: boolean | null;
  gitlabDeleteIssues?: boolean | null;
  calendarEnabled?: boolean | null;
  calendarApiEnabled?: boolean | null;
  outlookCalendarApiEnabled?: boolean | null;
  jiraServerUrl?: string | null;
  jiraPrefixType?: string | null;
  jiraServerPrefixType?: string | null;
  tempoOauthClientId?: string | null;
  tempoOauthClientSecret?: string | null;
  salesforceDeactivate?: boolean | null;
  salesforceAutoCreate?: boolean | null;
  xeroUninstall?: boolean | null;
  githubUnauthorizedInstallation?: number | null;
  githubDeactivate?: boolean | null;
  vstsDeactivate?: boolean | null;
  vstsEstimateField?: string | null;
  oktaClientId?: string | null;
  oktaClientSecret?: string | null;
  oktaUrl?: string | null;
  oktaDomainSuffix?: string | null;
  oneloginClientId?: string | null;
  oneloginClientSecret?: string | null;
  oneloginUrl?: string | null;
  unit4Enabled?: boolean | null;
  unit4TwoWay?: boolean | null;
  unit4SyncDateLimit?: string | null;
  AADClientId?: string | null;
  AADClientSecret?: string | null;
  AADTenant?: string | null;
  isUsingSchedulingPlanMode?: boolean | null;
  isUsingProjectAllocation?: boolean | null;
  isUsingMixedAllocation?: boolean | null;
  usingProjectAllocationCreateAllocations?: boolean | null;
  confirmAllocationDeletion?: boolean | null;
  userSeats?: number | null;
  collaboratorSeats?: number | null;
  virtualSeats?: number | null;
  timesheetReminderDay?: string | null;
  timesheetReminderHour?: number | null;
  timesheetReminderEnabled?: boolean | null;
  timesheetReminderIncludeToday?: boolean | null;
  projectDigestNotificationDay?: string | null;
  projectDigestNotificationHour?: number | null;
  projectDigestNotificationEnabled?: boolean | null;
  userCanUnlinkInvoice?: boolean | null;
  skillLevelsEnabled?: boolean | null;
  revenueEnabled?: boolean | null;
  timesheetsEnabled?: boolean | null;
  clientsEnabled?: boolean | null;
  betaOptIn?: boolean | null;
  weekendDisplayPerUser?: boolean | null;
  qboExportDefaultInvoiceRef?: boolean | null;
  qboExportDefaultDescription?: boolean | null;
  qboExportDefaultProjectNameInDesc?: boolean | null;
  qboExportDefaultTerms?: boolean | null;
  qboExportDefaultTax?: boolean | null;
  weekendDisplayShowAlways?: boolean | null;
  invoiceQuantityDecimals?: number | null;
  workDetailShowRates?: boolean | null;
  addFeatureFlagKeysForCypress?: ReadonlyArray<string | null> | null;
  isSSOMandatory?: boolean | null;
  sageIntacctTimeRegsFromForecast?: boolean | null;
  sageIntacctSyncOnlyApproved?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCompanySubscriptionDataMutation$variables = {
  input: UpdateCompanyInput;
};
export type updateCompanySubscriptionDataMutation$data = {
  readonly updateCompany: {
    readonly company: {
      readonly id: string;
      readonly userSeats: number | null;
      readonly collaboratorSeats: number | null;
      readonly virtualSeats: number | null;
      readonly subscription: {
        readonly seats: number | null;
        readonly collaboratorSeats: number | null;
        readonly virtualSeats: number | null;
      } | null;
    } | null;
  } | null;
};
export type updateCompanySubscriptionDataMutation = {
  variables: updateCompanySubscriptionDataMutation$variables;
  response: updateCompanySubscriptionDataMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSeats",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collaboratorSeats",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "virtualSeats",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seats",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanySubscriptionDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanyPayload",
        "kind": "LinkedField",
        "name": "updateCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanySubscriptionDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanyPayload",
        "kind": "LinkedField",
        "name": "updateCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4981e134dfbba11dbb2970679a6f309f",
    "id": null,
    "metadata": {},
    "name": "updateCompanySubscriptionDataMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanySubscriptionDataMutation(\n  $input: UpdateCompanyInput!\n) {\n  updateCompany(input: $input) {\n    company {\n      id\n      userSeats\n      collaboratorSeats\n      virtualSeats\n      subscription {\n        seats\n        collaboratorSeats\n        virtualSeats\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa53966c71db7d71d87b93280e1beea6";

export default node;
